import React from "react";
import LedgerRow from "./LedgerRow";

const LedgerTable = ({ ledgers }) => {
    if (!ledgers.length) {
        return (
            <div className="workspace-empty">
                <div className="workspace-empty-icon">◌</div>

                <h4>No ledgers yet</h4>

                <p>This business does not have any ledgers configured.</p>
            </div>
        );
    }

    return (
        <div className="ledger-table-wrapper">
            <table className="ledger-table">
                <thead>
                    <tr>
                        <th>Ledger</th>
                        <th>Group</th>
                        <th>Type</th>
                        <th>Balance Nature</th>
                        <th>Opening Balance</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    {ledgers.map((ledger) => (
                        <LedgerRow key={ledger.id} ledger={ledger} />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default LedgerTable;
